import type { PocInputValidity } from 'commons/types';
import { DeviceTypeSummary, RangeMode, ResultType, TestSummary } from '../material-definition.vm';
import { GeneralInfoCard } from './components/general-info-card';
import { LotRulesCard } from './components/lot-rules-card';
import { QcConfigCard } from './components/qc-config-card';
import { MaterialDefinitionFormState, QcLevelEditableField } from './settings-material-definitions-form.model';
import { FormErrors, QcTargetErrors } from './settings-material-definitions-form.validation';

interface SettingsMaterialDefinitionsFormComponentProps {
    formState: MaterialDefinitionFormState;
    onFieldChange: (
        field: keyof MaterialDefinitionFormState,
        value: MaterialDefinitionFormState[keyof MaterialDefinitionFormState]
    ) => void;
    onValidity?: (field: string, validity: PocInputValidity) => void;
    errors: FormErrors;
    testConfigsError?: string;
    targetErrors?: QcTargetErrors;
    deviceTypes: DeviceTypeSummary[];
    tests: TestSummary[];
    onAddTest: VoidFunction;
    onRemoveTest: (clientKey: string) => void;
    onTestChange: (clientKey: string, testId: string) => void;
    onResultTypeChange: (clientKey: string, resultType: ResultType) => void;
    onPossibleValuesChange: (clientKey: string, possibleValues: string) => void;
    onRangeModeChange: (clientKey: string, rangeMode: RangeMode) => void;
    onAddLevel: (clientKey: string, defaultName: string) => void;
    onRemoveLevel: (clientKey: string, index: number) => void;
    onLevelChange: (clientKey: string, index: number, field: QcLevelEditableField, value: string | null) => void;
    readOnlyLotRules?: boolean;
}

export const SettingsMaterialDefinitionsFormComponent: React.FC<SettingsMaterialDefinitionsFormComponentProps> = ({
    formState,
    onFieldChange,
    onValidity,
    errors,
    testConfigsError,
    targetErrors,
    deviceTypes,
    tests,
    onAddTest,
    onRemoveTest,
    onTestChange,
    onResultTypeChange,
    onPossibleValuesChange,
    onRangeModeChange,
    onAddLevel,
    onRemoveLevel,
    onLevelChange,
    readOnlyLotRules = false,
}) => (
    <>
        <GeneralInfoCard
            formState={formState}
            onFieldChange={onFieldChange}
            onValidity={onValidity}
            errors={errors}
            deviceTypes={deviceTypes}
        />
        <QcConfigCard
            testConfigs={formState.testConfigs}
            tests={tests}
            onAddTest={onAddTest}
            onRemoveTest={onRemoveTest}
            onTestChange={onTestChange}
            onResultTypeChange={onResultTypeChange}
            onPossibleValuesChange={onPossibleValuesChange}
            onRangeModeChange={onRangeModeChange}
            onAddLevel={onAddLevel}
            onRemoveLevel={onRemoveLevel}
            onLevelChange={onLevelChange}
            error={testConfigsError}
            targetErrors={targetErrors}
        />
        <LotRulesCard
            formState={formState}
            onFieldChange={onFieldChange}
            onValidity={onValidity}
            errors={errors}
            readOnly={readOnlyLotRules}
        />
    </>
);
